module.exports = __webpack_public_path__ + "static/media/share.5a871ffa.svg";